import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-vestment-color-display',
  templateUrl: './vestment-color-display.component.html',
  styleUrls: ['./vestment-color-display.component.css']
})
export class VestmentColorDisplayComponent implements OnInit {

  @Input() public colors: string[];
  constructor() { }

  ngOnInit() {
  }

}
